SupportV1INTLStepThreeView = require('../../views/step_three/INTL/v1_view')
SupportV1StepOneView = require('../../views/step_one/v1_view')
SupportV1StepActionsModel = require('../../models/v1_step_action')
SupportCMSModel = require('../../models/CMS')
StepTwoV1CMSView = require('../../views/step_two/CMS/v1_cms_view')
SupportHorizontalViewManagerBase = require('../horizontal_view_manager_base')
SupportOptimizedContactChannelsModel = require('../../models/optimized_contact_channels')

class SupportV1INTLViewManager extends SupportHorizontalViewManagerBase
  constructor: () ->
    SupportHorizontalViewManagerBase::constructor.apply(this, arguments)
    Groupon.Support.stepActionModel = new SupportV1StepActionsModel

  getStepOneView: ->
    new SupportV1StepOneView()

  getStepTwoView: ->
    Groupon.Support.StepTwoView = new StepTwoV1CMSView({
       dropDownModel: Groupon.Support.ContentModel.dropDowns
    })

  getStepThreeView: ->
    new SupportV1INTLStepThreeView()

  configureContentModel: ->
    Groupon.Support.ContentModel = new SupportCMSModel

  configureOptimizedContactChannelsModel: ->
    Groupon.Support.OptimizedContactChannelsModel = new SupportOptimizedContactChannelsModel

module.exports = SupportV1INTLViewManager
